import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Checkbox } from 'ui-components/components/checkbox';
import { ResidentialIndicator, isResidential } from '../../../enums/residential-indicator';
import { messages } from '../messages';
import style from '../style.module.less';

export const ResidentialCheckbox = ({ residentialIndicator = null, onChange: onChangeProp }) => {
  const intl = useIntl();

  const onChange = useCallback(
    (checked) => {
      const indicator = checked ? ResidentialIndicator.Residential : ResidentialIndicator.Unknown;
      onChangeProp(indicator);
    },
    [onChangeProp],
  );

  return (
    <Checkbox
      checked={isResidential(residentialIndicator)}
      className={style.checkbox}
      label={intl.formatMessage(messages.isResidential)}
      onChange={onChange}
    />
  );
};

ResidentialCheckbox.propTypes = {
  residentialIndicator: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
